/* eslint max-len: 0 */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import { Layout, LayoutItem } from './Layout';
import { Gallery, GalleryItem } from './Gallery';

function mapStateToProps(state) {
  const { newProducts } = state;

  return { items: newProducts.items };
}

@connect(mapStateToProps)
export default class SectionNewProducts extends React.Component {
  static propTypes = {
    items: PropTypes.array,
  };

  render() {
    const { items } = this.props;

    const sectionBg = require('images/new-products-bg.svg');
    const title = i18n.translate('newProducts.title');

    return (
      <Section id="new-products" color="green" sectionBg={sectionBg} title={title}>
        <Layout direction="column">
          <LayoutItem>
            <p dangerouslySetInnerHTML={{ __html: i18n.translate('newProducts.p1') }}></p>
          </LayoutItem>
          <LayoutItem>
            <Gallery>
              {items.map((i, index) => <GalleryItem key={`gallery-item-${index}`} {...i} />)}
            </Gallery>
          </LayoutItem>
        </Layout>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionNewProducts.jsx
 **/